import { AppStatusFilterOptions, ActionButtonTypes, ApplicationListData, FirmSearchOption, RenewalsListData } from '../dtos/portal'

export const portalLinks: {[key: string]: {name: string, route: string}[]} = {
  admin: [
    { name: 'Firms', route: '/admin' },
    { name: 'Applications', route: '/admin/applications' },
  ],
  customer: [
    { name: 'Firm Information', route: '/customer' },
    { name: 'Quote', route: '/customer/quote' },
    { name: 'Policy', route: '/customer/policy' },
    { name: 'Invoices', route: '/customer/invoices' },
    { name: 'Cyber Risk Management', route: '/customer/risk-management' },
  ]
}

export const dropdownFilterOptions = [
  'Oldest to Newest',
  'Newest to Oldest',
  'Alphabetical A - Z',
  'Alphabetical Z - A',
  'Progress 0% - 100%',
  'Progress 100% - 0%'
] as const

export const dropdownDatesFilterOptions = [
  'Month to date',
  '30 days',
  '60 days',
  '90 days',
  'Year to date',
  'Last 12 months'
] as const

export const appListRowType: {
  [type in AppStatusFilterOptions]: {
    columns: string[];
    applicationProps: Array<keyof ApplicationListData>
  }
} = {
  IN_PROGRESS: {
    columns: ['Applicant Name', 'Applicant Type', 'Date Started','Last Worked On', 'Progress', 'Reminders'],
    applicationProps: ['firmName', 'applicantType', 'dateStarted', 'dateUpdated', 'percentageOfCompletion', 'reminders']
  },
  COMPLETED: {
    columns: ['Applicant Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed'],
    applicationProps: ['firmName', 'applicantType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted']
  },
  SUBMITTED: {
    columns: ['Applicant Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed', 'Date Submitted'],
    applicationProps: ['firmName', 'applicantType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted', 'dateSubmitted']
  },
  REJECTED: {
    columns: ['Applicant Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed', 'Date Rejected'],
    applicationProps: ['firmName', 'applicantType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted', 'dateRejected']
  },
  EXPIRING_POLICIES: {
    columns: [],
    applicationProps: []
  }
}

export const renewalListRowType: {
  [type in AppStatusFilterOptions]: {
    columns: string[];
    applicationProps: Array<keyof RenewalsListData>
  }
} = {
  IN_PROGRESS: {
    columns: ['Firm Name', 'Applicant Type', 'Policy Number', 'Policy Expiration', 'Date Started','Last Worked On', 'Progress', 'Reminders'],
    applicationProps: ['firmName', 'userType', 'policyNumber', 'policyExpiryDate', 'dateStarted', 'dateUpdated', 'percentageOfCompletion', 'reminders']
  },
  COMPLETED: {
    columns: ['Firm Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed'],
    applicationProps: ['firmName', 'userType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted']
  },
  SUBMITTED: {
    columns: ['Firm Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed', 'Date Submitted'],
    applicationProps: ['firmName', 'userType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted', 'dateSubmitted']
  },
  REJECTED: {
    columns: ['Firm Name', 'Applicant Type', 'Firm Size', 'Date Started','Last Worked On', 'Date Completed', 'Date Rejected'],
    applicationProps: ['firmName', 'userType', 'firmSize', 'dateStarted', 'dateUpdated', 'dateCompleted', 'dateRejected']
  },
  EXPIRING_POLICIES: {
    columns: ['Firm Name', 'Applicant Type', 'Policy Number', 'Policy Expiration', 'Reminders Sent'],
    applicationProps: ['firmName', 'userType', 'policyNumber', 'policyExpiryDate', 'renewalReminder']
  }
}

export const dateFormatData = ['dateStarted', 'dateCompleted', 'dateRejected', 'policyExpiryDate', 'dateSubmitted', 'dateUpdated', 'reminders']

export const actionButtonsToRenderInHoveredRow: {[button in ActionButtonTypes]: AppStatusFilterOptions[]} = {
  SEND_REMINDER: ['IN_PROGRESS'],
  REJECT: ['IN_PROGRESS', 'COMPLETED'],
  SUBMIT: ['COMPLETED'], 
  DOWNLOAD: ['COMPLETED', 'SUBMITTED', 'REJECTED'], 
  CONTACT: ['COMPLETED', 'SUBMITTED', 'REJECTED', 'EXPIRING_POLICIES'], 
  DELETE: ['REJECTED'],
  IMPERSONATE : ['IN_PROGRESS']
}

export const statusValuesToFetchApplications = {
  IN_PROGRESS: 0,
  COMPLETED: 1,
  SUBMITTED: 2,
  REJECTED: 3,
  EXPIRING_POLICIES: 0
}

export const statusToCapitalizedName = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  EXPIRING_POLICIES: 'Expiring Policies'
}

export const firmSearchOptionsToRequest: {[key in FirmSearchOption]: string} = {
  FIRM_NUMBER: 'FirmNumber',
  FIRM_NAME: 'Name',
  ADMIN_FIRST_NAME: 'AdminFirstName',
  ADMIN_LAST_NAME: 'AdminLastName',
  EMAIL: 'Email',
  POLICY_NUMBER: 'PolicyNumber',
  QUOTE_NUMBER: 'QuoteNumber'
}